// extracted by mini-css-extract-plugin
module.exports = {"alert":"notice_alert__fyXuM","closebtn":"notice_closebtn__GDdPf","close":"notice_close__3QFVx"};